<template>
    <div class="flash-sale mt-8 bg-white">
      <div class="flash-sale__header flex justify-between items-center h-24 px-8">
        <div class="flash-sale__header__title h-full">
          <div class="flash-sale__header__title__wrapper flex justify-center items-center h-full">
            <div class="flash-sale__header__title__wrapper__header" :style="url(img)"></div>
            <div class="flash-sale__header__title__wrapper__timer ml-4">
              <span>{{ hours }}</span>:<span>{{ minutes }}</span>:<span>{{ seconds }}</span>
            </div>
          </div>
        </div>
        <a href="" class="flash-sale__header__link">
          <button class="flash-sale__header__btn text-2xl text-primary-color">
            ดูทั้งหมด
            <i class="far fa-angle-right text-2xl"></i>
          </button>
        </a>
      </div>
  
      <FlashSaleList/>
    </div>
  </template>
  
  <script>
  import FlashSaleList from './FlashSaleList.vue';
  
  export default {
    name: 'FlashSale',
    components: {
      FlashSaleList,
    },
    data() {
      return {
        img: 'https://deo.shopeemobile.com/shopee/shopee-pcmall-live-sg/flashsale/fb1088de81e42c4e538967ec12cb5caa.png',
        hours: '02',
        minutes: '09',
        seconds: '03',
      };
    },
    methods: {
      url(url) {
        return `background-image: url(${url});`;
      },
      startCountdown() {
        setInterval(() => {
          let totalSeconds = parseInt(this.hours) * 3600 + parseInt(this.minutes) * 60 + parseInt(this.seconds);
          totalSeconds -= 1;
  
          if (totalSeconds >= 0) {
            this.hours = this.formatTime(Math.floor((totalSeconds / 3600) % 24));
            this.minutes = this.formatTime(Math.floor((totalSeconds / 60) % 60));
            this.seconds = this.formatTime(Math.floor(totalSeconds % 60));
          } else {
            clearInterval(this.timer);
          }
        }, 1000);
      },
      formatTime(time) {
        return time < 10 ? `0${time}` : `${time}`;
      },
    },
    mounted() {
      this.startCountdown();
    },
  };
  </script>

<style scoped>
.flash-sale__header__title__wrapper__header{
    width: 11.4rem;
    height: 3rem;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.flash-sale__header__title__wrapper__timer span{
    background-color: #000;
    width: 2rem;
    height: 2rem;
    padding: .2rem .4rem;
    margin: 0 .4rem;
    color: #fff;
    font-size: 1.4rem;
}
</style>
